import React from "react";

import "./error-card.component.scss";

const ErrorCard = ({ onRefresh }) => {
  return (
    <section className="relative z-10 py-[120px] error-card">
      <div className="container mx-auto">
        <div className="-mx-4 flex">
          <div className="w-full px-4">
            <div className="mx-auto max-w-[400px] text-center">
              <h4 className="mb-3 text-[22px] font-semibold leading-tight text-red-600">
                Oops! Something went wrong while loading the data
              </h4>

              <a
                onClick={onRefresh}
                className="hover:text-primary inline-block rounded-lg border border-red-600 px-8 py-3 text-center text-base font-semibold text-red-600 transition hover:bg-white on-refresh"
              >
                Refresh
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 left-0 -z-10 flex h-full w-full items-center justify-between space-x-5 md:space-x-8 lg:space-x-14"></div>
    </section>
  );
};
export default ErrorCard;
